var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24 4H0V20H24V4Z","fill":"#F6C358","key":0}),React.createElement("path",{"d":"M12 10.5742L24 20.0006H0L12 10.5742Z","fill":"#FCD462","key":1}),React.createElement("path",{"d":"M12 14.2977L0 4H24L12 14.2977Z","fill":"#DC8744","key":2}),React.createElement("path",{"d":"M12 13.4263L0 4H24L12 13.4263Z","fill":"#FCD462","key":3})]);
}

Email.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Email;

Email.default = Email;
